export default __webpack_public_path__ + "static/media/circulo-negado.0f4f589a.svg";